// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2RJwm","left":"InfoRow_left__14HwD"};